<h1 mat-dialog-title>Connessione persa</h1>
<div mat-dialog-content>
  <div class="spinnerWrapper">
    <mat-spinner></mat-spinner>
  </div>
  <ng-container *ngIf="showRetryButton">
    <div class="actionsContainer">
      <button mat-stroked-button color="basic" (click)="dialogRef.close()">Annulla</button>
      <button mat-flat-button color="warn" (click)="dialogRef.close()">Riprova</button> <!--qui non viene proprio gestita la riconnessione. implementare.-->
    </div>
  </ng-container>

</div>
